<template>
  <div>
    <v-snackbar
      v-model="snackbar"
      auto-height
      :color="sColor"
      :timeout="sTimeout"
      dismissible
      right
      top
      vertical
    >
      {{ humanize(sText) }}
      <router-link
        class="my-3"
        v-show="sPath"
        :to="{ params: sParams, path: sPath }"
        >{{ sTextLink }}</router-link
      >
      <v-btn
        v-show="sPath"
        flat
        small
        icon
        @click="$router.push({ params: sParams, path: sPath })"
      >
        <v-icon color="black" small>add</v-icon>
      </v-btn>
      <!-- <div v-else>
        {{ sText }}
      </div>-->
    </v-snackbar>

    <!-- CHANGE LOCATION DIALOG -->
    <location-change-dialog
      v-if="isAuthenticated"
      :showDialog="show_change_location_dialog"
      @hideDialog="show_change_location_dialog = !show_change_location_dialog"
      :selected="selected"
    ></location-change-dialog>

    <v-dialog v-model="add_to_series_dialog" max-width="560px">
      <v-card>
        <v-card-title>
          <span class="title font-weight-light">Add selected to artwork series</span>
          <v-spacer></v-spacer>
          <v-btn icon @click="closeAddToSeriesDialog">
            <v-icon small>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <div class="body-1 mb-3">
            Add {{ selected.length }} selected artwork{{ selected.length === 1 ? '' : 's' }} to a new or existing series?
          </div>
          <v-layout row wrap>
            <v-btn color="black" dark @click="openNewArtworkSeries">
              New
            </v-btn>
            <v-btn outline color="black" @click="show_existing_series_picker = true">
              Existing
            </v-btn>
          </v-layout>

          <div v-if="show_existing_series_picker" class="mt-4">
            <v-autocomplete
              v-model="selected_series_id"
              :items="artwork_series"
              :loading="artwork_series_loading"
              item-value="id"
              item-text="searchLabel"
              label="Select artwork series"
              clearable
              hide-details
            ></v-autocomplete>
            <v-checkbox
              v-model="reset_selection_after_series_add"
              label="Reset current selection"
              color="black"
              hide-details
              class="mt-3"
            ></v-checkbox>
          </div>
        </v-card-text>
        <v-card-actions v-if="show_existing_series_picker">
          <v-spacer></v-spacer>
          <v-btn flat @click="closeAddToSeriesDialog">Cancel</v-btn>
          <v-btn
            color="black"
            dark
            :disabled="!selected_series_id"
            :loading="adding_to_series"
            @click="addSelectionToExistingSeries(true)"
          >
            Add to series and go to series
          </v-btn>
          <v-btn
            outline
            color="black"
            :disabled="!selected_series_id"
            :loading="adding_to_series"
            @click="addSelectionToExistingSeries(false)"
          >
            Add to series
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- DIALOG OF CURRENT SELECTION     -->
    <!-- <v-layout row justify-center> -->
    <v-dialog v-model="selections_dialog" max-width="700px">
      <!-- <v-btn color="primary" dark slot="activator">Open Dialog</v-btn> -->

      <v-card elevation-0 style="width: 700px" class="round mx-0">
        <v-card-title>
          <span class="title font-weight-light ml-3"
            >Saved Artwork Selections</span
          >
          <!-- <h2 class="title ml-2">Saved Artwork Selections</h2> -->
          <v-spacer></v-spacer>
          <v-btn icon @click.native="selections_dialog = false">
            <v-icon small>close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-title class="mx-3 mt-0 pt-0">
          <v-text-field
            append-icon="search"
            label="Filter by Selection Names, Creation Date or No. of Artworks"
            single-line
            hide-details
            clearable
            v-model="selectionSearch"
          ></v-text-field>
        </v-card-title>

        <v-data-table
          :headers="listHeaders"
          :items="selections"
          :pagination.sync="ps"
          must-sort
          class="elevation-0"
          item-key="id"
          loading="true"
          no-results-text="No matching Selection found."
          :search="selectionSearch"
        >
          <template v-slot:headers="props">
            <tr style="height=30px">
              <th
                :align="props.align"
                v-for="header in props.headers"
                :key="header.text"
                :class="[
                  'column sortable',
                  ps.descending ? 'desc' : 'asc',
                  header.value === ps.sortBy ? 'active' : '',
                  `text-xs-${header.align}`,
                  'pl-2 pr-4 my-0 py-0',
                ]"
                @click="changeSortSelection(header.value)"
              >
                <v-icon small>arrow_upward</v-icon>
                <span class="pr-2 pl-1">{{ header.text }}</span>
              </th>
            </tr>
          </template>

          <template slot="items" slot-scope="props">
            <tr>
              <td colspan="3" class="mx-0 px-0">
                <v-layout class="px-2 mt-3 pb-2 no-wrap" style="width: 675px">
                  <span
                    class="
                      title
                      font-weight-light
                      px-4
                      no-wrap
                      text-uppercase text-truncate
                    "
                    >{{ props.item.name }} {{ props.item.title }} [{{
                      props.item.artworks.length
                    }}]</span
                  >
                  <!-- <div class="grey--text">{{format_date(item.created_at)}} by {{item.created_by ? getUser(item.created_by).abb : 'nobody'}}</div> -->
                  <v-spacer></v-spacer>
                  <span class="ml-0 text-xs-right pl-0 no-wrap">{{
                    format_date(props.item.created_at)
                  }}</span>
                </v-layout>

                <v-layout class="px-4 pb-2">
                  <v-tooltip bottom class="mr-3">
                    <template v-slot:activator="{ on }">
                      <v-btn
                        color="black"
                        icon
                        small
                        @click="loadSelection(props.item.artworks)"
                        v-on="on"
                      >
                        <v-icon small color="white">apps</v-icon>
                      </v-btn>
                    </template>
                    <span
                      >Replace Current Selection with this saved Selection</span
                    >
                  </v-tooltip>

                  <v-tooltip bottom class="mr-3">
                    <template v-slot:activator="{ on }">
                      <v-btn
                        color="black"
                        icon
                        small
                        @click="addToSelection(props.item.artworks)"
                        v-on="on"
                      >
                        <v-icon small color="white">add</v-icon>
                      </v-btn>
                    </template>
                    <span
                      >Add Artworks in this Selection to current Selection</span
                    >
                  </v-tooltip>

                  <!-- <v-tooltip bottom class="mr-0">
                    <template v-slot:activator="{ on }">-->
                  <list-action-menu :item="props.item" ids></list-action-menu>
                  <!-- </template>
                        <span>Download predefined PDF or Excel from this Selection</span>
                    </v-tooltip>-->
                  <!-- <v-btn icon small @click="addToSelection(item.artworks)">
                        <v-icon small color="white">add</v-icon>
                    </v-btn>-->
                  <!-- <v-btn icon>
                        <v-icon color="green">favorite</v-icon>
                    </v-btn>-->

                  <v-tooltip bottom class="mr-3">
                    <template v-slot:activator="{ on }">
                      <v-btn
                        class="ml-4"
                        icon
                        color="red"
                        v-on="on"
                        small
                        outline
                        @click="removeFromSelections(props.item)"
                        v-if="c_user.edit || c_user.delete_rights"
                      >
                        <v-icon small>delete</v-icon>
                      </v-btn>
                    </template>
                    <span>Delete Selection</span>
                  </v-tooltip>
                  <!-- <v-spacer></v-spacer> -->
                  <!-- <labels :item="props.item" small="small" light="light"></labels>
                    <labels-small :item="props.item" small="small" light="light"></labels-small>-->
                </v-layout>
              </td>
            </tr>
          </template>

          <template slot="no-data">
            <v-alert :value="true" color="error" icon="warning">
              <v-btn @click="reload_data('Lists')"
                >No Selection loaded, click here to load from the server.</v-btn
              >
            </v-alert>
          </template>
        </v-data-table>
      </v-card>
    </v-dialog>
    <!-- </v-layout> -->

    <!-- <Login v-if="!isAuthenticated"></Login> -->
    <!-- TOP TOOLBAR WITH MENU AND ICONS -->
    <!-- style="height: 140px;" -->
    <v-toolbar
      app
      class="pt-2 pb-0 elevation-0 white mb-0 px-2"
      extended
      v-if="isAuthenticated"
    >
      <!-- <v-toolbar-side-icon class="icon" @click.stop="drawer = !drawer"></v-toolbar-side-icon> -->
      <v-toolbar-title class="pt-3 mx-1 mb-0 pb-0">
        <router-link to="/artworks/ownership/collection" class="logo my-0 py-0">
          <span class="font-weight-regular display-1 hidden-xs-only"
            >TBA21</span
          >
        </router-link>
        <router-link :to="page_link" class="logo my-0 py-0 text-truncate">{{
          page_title
        }}</router-link>
        <!-- <router-link to="/location_overview" class="logo my-0 py-0 text-truncate">{{
          'location_overview'
        }}</router-link> -->
      </v-toolbar-title>

      <!-- <v-spacer></v-spacer> -->

      <!-- <v-toolbar-items class="hidden-sm-and-down"> -->
      <!-- <v-btn icon v-if="$store.getters.loading"> -->
      <!-- <v-icon color='red'>sync</v-icon> -->
      <!-- </v-btn> -->
      <!-- {{ my_todos.length }}/
      {{ my_late_todos.length }}/
      {{ format_date(Date.now()) }} -->

      <!-- SELECTIONS MENU & LOADING indicator -->
      <v-flex class="text-xs-right mb-0 pt-3">
        <span v-if="loadErrorMessages.length > 0" class="error--text caption mr-3">
          {{ loadErrorMessages[0] }}<span v-if="loadErrorMessages.length > 1">
            (+{{ loadErrorMessages.length - 1 }} more)</span>
        </span>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <!-- <v-btn color="primary" dark v-on="on">Button</v-btn> -->
            <span v-on="on">
              <v-progress-circular
                v-show="($store.getters.loading || progressON) && loadErrorMessages.length === 0"
                indeterminate
                size="20"
                width="2"
                class="mr-5"
              ></v-progress-circular>
              <v-icon
                v-if="loadErrorMessages.length > 0"
                color="error"
                class="mr-5"
              >error</v-icon>
            </span>
          </template>
          <div v-for="message in loadErrorMessages" :key="message" class="error--text">
            {{ message }}
          </div>
          <div v-show="$store.state.loading_artworks">Loading Artworks</div>
          <div v-show="$store.state.loading_artists">Loading Artists</div>
          <div v-show="$store.state.loading_rules">Loading Rules</div>
          <div v-show="$store.state.loading_contacts">Loading Contacts</div>
          <div v-show="$store.state.loading_lists">Loading Lists</div>
          <div v-show="$store.state.loading_locations">Loading Locations</div>
          <div v-show="$store.state.loading_exhibitions">
            Loading Exhibitions
          </div>
          <div v-show="$store.state.loading_packings">Loading Packings</div>
          <div v-show="$store.state.loading_texts">Loading Text</div>
          <div v-show="$store.state.loading_tags">Loading Tags</div>
          <div v-show="$store.state.loading_tag_categories">
            Loading Tag Categories
          </div>
          <div v-show="$store.state.loading_todos">Loading Todos</div>
          <div v-show="$store.state.loading_support_articles">
            Loading Support Articles
          </div>
          <div v-show="$store.state.loading_journals">Loading Journals</div>
          <div v-show="$store.state.loading_questions">Loading Questions</div>
        </v-tooltip>

        <v-menu
          offset-y
          :close-on-content-click="false"
          :nudge-width="400"
          v-model="menu"
        >
          <template v-slot:activator="{ on }">
            <v-badge
              overlap
              class="mt-2 pt-0 mr-3"
              :value="selected.length"
              color="black"
            >
              <template v-slot:badge>
                <span>{{ selected.length }}</span>
              </template>
              <v-btn icon v-on="on" class="mt-0 mr-0">
                <v-icon :color="selected.length > 0 ? 'green' : 'black'"
                  >auto_awesome_motion</v-icon
                >
              </v-btn>
            </v-badge>

            <!-- <span class="headline mx-2">{{ selected.length }}</span>
            <span
              style="line-height: 11px; font-size: 10px; margin-right: 30px"
              class="text-xs-left"
            >
            <v-icon color="black" size="22">auto_awesome_motion</v-icon>
            </span> -->
          </template>
          <!-- v-show="this.selected.length>0" -->
          <!-- <v-btn icon> -->
          <!-- <v-badge left color="green" overlap>
          <div slot="badge" dark small>{{selected.length}}</div>-->
          <!-- <v-icon>apps</v-icon> -->
          <!-- </v-badge> -->
          <!-- </v-btn> -->

          <v-list class="px-2" two-line>
            <!-- <v-list> -->

            <v-list-tile class="my-0" v-if="isArtworkListPage">
              <v-btn outline small @click="addAllShownArtworksToCurrentSelection">
                <v-icon class="mr-2">playlist_add</v-icon>Add all to current selection
              </v-btn>
            </v-list-tile>

            <v-list-tile class="my-0">
              <v-btn outline small @click="openSelectionsdialog()">
                <v-icon class="mr-2">get_app</v-icon>Load saved Artwork
                Selection (list)
              </v-btn>
            </v-list-tile>

            <v-list-tile class="my-0" v-if="selected.length > 0 && c_user.edit">
              <v-btn dark @click="show_change_location_dialog = true">
                <v-icon class="mr-2">edit_location</v-icon>Change location of
                selected
              </v-btn>
            </v-list-tile>

            <v-list-tile class="my-0" v-if="selected.length > 0 && c_user.edit">
              <v-btn outline small @click="openAddToSeriesDialog">
                <v-icon class="mr-2">playlist_add</v-icon>Add selected to artwork series
              </v-btn>
            </v-list-tile>

            <!-- <v-list-tile class="mt-0 pt-0" v-if="selected.length>0">
              <v-list-tile-title class="ml-3 my-0 py-0">
              </v-list-tile-title>
            </v-list-tile>-->

            <v-list-tile class="my-0 py-0" v-if="selected.length > 0">
              <v-list-tile-title
                class="layout row wrap ml-0 my-0 py-0"
                style="height: 70px"
              >
                <v-flex xs2 pl-3>
                  <list-action-menu use-current-selection></list-action-menu>
                </v-flex>
                <v-flex xs10 pt-2 text-xs-left pl-3
                  >{{ selected.length }} currently selected Artworks.</v-flex
                >
              </v-list-tile-title>
            </v-list-tile>

            <v-list-tile v-if="!save_selection_form_display" class="ml-0 pl-1">
              <!-- <v-list-tile-action v-if="this.selected.length>0"> -->
              <v-btn
                outline
                small
                color="error"
                @click="clear_selection"
                v-if="selected.length > 0"
              >
                <v-icon class="mr-2">clear</v-icon>Clear selection
              </v-btn>
              <!-- <v-icon>delete</v-icon> -->
              <!-- </v-list-tile-action> -->
              <v-spacer></v-spacer>

              <!-- <v-list-tile-action v-if="this.selected.length>0"> -->
              <!-- <v-btn outline small @click="menu=false">Cancel</v-btn> -->
              <!-- </v-list-tile-action> -->

              <!-- <v-list-tile-action v-if="this.selected.length>0"> -->
              <v-btn
                v-if="selected.length > 0"
                dark
                small
                color="primary"
                @click="save_selection_form_display = true"
              >
                <v-icon class="mr-2">save</v-icon>Save selection
              </v-btn>
              <!-- </v-list-tile-action> -->
            </v-list-tile>

            <v-list-tile v-else>
              <!-- <v-list-tile-content class="py-4 pl-3"> -->
              <!-- <v-layout row xs12 > -->
              <v-flex xs12 mx-3>
                <v-text-field
                  v-model="selection_title"
                  label="Selection Title"
                  value
                ></v-text-field>
              </v-flex>
              <!-- </v-layout> -->
              <!-- </v-list-tile-content> -->
            </v-list-tile>

            <v-list-tile
              v-if="save_selection_form_display"
              class="layout justify-end mr-2"
            >
              <v-btn outline small @click="save_selection_form_display = false"
                >Cancel</v-btn
              >
              <v-btn dark small @click="saveCurrentSelectionToUser">Save</v-btn>
            </v-list-tile>

            <v-list-tile v-if="save_selection_error" class="mx-4 mb-4 red">{{
              save_selection_error
            }}</v-list-tile>
          </v-list>
          <!-- <v-divider></v-divider> -->

          <!-- </v-list> -->
        </v-menu>
      </v-flex>

      <!-- ADD NEW MENU -->
      <v-menu offset-y v-if="c_user.edit">
        <template v-slot:activator="{ on }">
          <v-btn icon color="black" flat class="mt-4 mr-3" round v-on="on">
            <v-icon color="black">add</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-tile @click="$router.push({ path: '/artworks/new' })">
            <v-list-tile-title>New Artwork</v-list-tile-title>
          </v-list-tile>
          <v-list-tile @click="$router.push({ path: '/artists/new' })">
            <v-list-tile-title>New Artist</v-list-tile-title>
          </v-list-tile>
          <v-list-tile @click="$router.push({ path: '/tags/new' })">
            <v-list-tile-title>New Tag</v-list-tile-title>
          </v-list-tile>
          <v-list-tile @click="$router.push({ path: '/exhibitions/new' })">
            <v-list-tile-title>New Exhibition</v-list-tile-title>
          </v-list-tile>
          <v-list-tile @click="add_new = !add_new">
            <v-list-tile-title>New User</v-list-tile-title>
          </v-list-tile>
          <v-list-tile @click="$router.push({ path: '/locations/new' })">
            <v-list-tile-title>New Location</v-list-tile-title>
          </v-list-tile>
          <v-list-tile @click="$router.push({ name: 'AddContact' })">
            <v-list-tile-title>New Contact</v-list-tile-title>
          </v-list-tile>
          <v-list-tile @click="$router.push({ path: '/reports/new' })">
            <v-list-tile-title>New Report</v-list-tile-title>
          </v-list-tile>
          <v-list-tile @click="$router.push({ path: '/texts/new' })">
            <v-list-tile-title>New Text</v-list-tile-title>
          </v-list-tile>
          <v-list-tile @click="$router.push({ path: '/todos/new' })">
            <v-list-tile-title>New Todo</v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-menu>

      <!-- <v-badge color="red" left overlap>
        <template v-slot:badge>
          {{userTodos.length}}
        </template>
        <v-icon>notifications</v-icon>
      </v-badge>-->

      <!-- <v-btn icon>
        <v-icon>notifications</v-icon>
        {{userTodos.length}}
      </v-btn>-->

      <!-- ACCOUNT MENU -->
      <!-- :nudge-width="200" -->

      <v-menu offset-y fixed v-if="c_user.edit" :close-on-content-click="false">
        <template v-slot:activator="{ on }">
          <v-badge
            overlap
            class="mt-4 mr-4 pt-0 mr-3"
            :value="my_late_todos.length > 0 || messages.length > 0"
            :color="my_late_todos.length > 0 ? '#bc0000' : 'black'"
          >
            <template v-slot:badge>
              <span>{{ my_late_todos.length }}</span>
            </template>
            <v-btn icon v-on="on" class="mt-0 mr-0">
              <v-icon color="black">notifications_none</v-icon>
              <!-- v-if="my_late_todos.length > 0" -->
            </v-btn>
          </v-badge>
        </template>

        <v-card style="width: 650px">
          <v-flex
            xs12
            v-if="
              c_user &&
              c_user.roles &&
              c_user.roles.find((r) => r.shortcut == 'todos')
            "
          >
            <v-subheader
              key="sss"
              style="
                font-size: 20px;
                padding-left: 30px;
                background-color: #eee;
                color: #333;
              "
            >
              TODOS
              <v-spacer></v-spacer>
              <v-text-field
                class="mb-3"
                prepend-inner-icon="search"
                flat
                clearable
                hide-details
                v-model="todoSearch"
              ></v-text-field>
              <span xs1 class="text-xs-right mr-0 mt-2 py-0">
                <v-btn
                  icon
                  @click="showAllTodos = !showAllTodos"
                  class="text-xs-right mx-0 mt-2 my-0 py-0"
                >
                  <v-icon v-if="showAllTodos" color="red">check_circle</v-icon>
                  <v-icon v-else color="grey" dark>check_circle_outline</v-icon>
                </v-btn>
              </span>

              <!-- label="filter" -->
            </v-subheader>

            <v-data-table
              :pagination.sync="tp"
              must-sort
              :headers="todoHeaders"
              :items="my_todos"
              style="width: 650px"
              class="elevation-0"
              item-key="id"
              loading="true"
              no-results-text="No matching Todos found."
              :search="todoSearch"
            >
              <template slot="items" slot-scope="props">
                <tr>
                  <td colspan="4" class="elevation-0 mx-0 px-0">
                    <v-list two-line style="width: 650px">
                      <v-list-tile>
                        <v-list-tile-content>
                          <v-list-tile-title
                            class="text-truncate text-uppercase"
                            style="line-height: 2.5"
                          >
                            <b>{{ props.item.title }}</b>
                          </v-list-tile-title>
                          <v-list-tile-sub-title>
                            <router-link
                              style="width: 120px"
                              class="body-2 text-truncate"
                              :to="{
                                name: 'EditArtwork',
                                params: {
                                  id: props.item.artwork_id,
                                  artwork: { id: props.item.artwork_id },
                                },
                                path: `/artworks/edit/${props.item.artwork_id}`,
                              }"
                            >
                              <!-- <span :class="{'red--text': a.deaccessioned}">{{ a.title }}, {{ a.production_date_new }}</span> -->
                              <v-icon class="mr-2" color="black" small
                                >launch</v-icon
                              >
                              {{ getArtwork(props.item.artwork_id) }}
                            </router-link>
                          </v-list-tile-sub-title>
                          <v-list-tile-sub-title style="line-height: 2.5">
                            <span class="mr-5"
                              >Created:
                              {{ format_date(props.item.created_at) }}</span
                            >
                            <span class="mr-5 green" v-if="props.item.done_at"
                              >Done at:
                              {{ format_date(props.item.done_at) }}</span
                            >
                            <v-icon
                              v-if="props.item.deadline"
                              small
                              :color="getColor(props.item)"
                              >alarm_on</v-icon
                            >
                            <span v-if="props.item.deadline">{{
                              format_date(props.item.deadline)
                            }}</span>
                          </v-list-tile-sub-title>
                        </v-list-tile-content>

                        <v-list-tile-action class="px-2">
                          <v-btn
                            icon
                            :class="props.item.done ? 'dark' : ''"
                            @click="toggleTodo(props.item)"
                          >
                            <v-icon
                              v-if="props.item.done == 1"
                              class="mr-0 pl-0 ml-0"
                              >check_box</v-icon
                            >
                            <v-icon v-else class="mr-0 pl-0 ml-0"
                              >check_box_outline_blank</v-icon
                            >
                            <!-- <v-icon v-if="props.item.done" class="mr-0" color="black" >check_box</v-icon> -->
                            <!-- <span v-if="props.item.done">DONE</span>
                            <span v-if="!props.item.done" class="red--text">ACTIVE</span>-->
                          </v-btn>

                          <!-- <v-checkbox
                            :value="props.item.done"
                            color="black"
                            hint="Mark as done"
                            @change="toggleTodo(props.item)"
                          ></v-checkbox>-->
                        </v-list-tile-action>
                      </v-list-tile>
                    </v-list>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </v-flex>
        </v-card>
      </v-menu>

      <!-- v-model="account_menu" -->
      <v-menu
        :close-on-content-click="false"
        offset-y
        fixed
        style="background-color: white; top: 80px; position: fixed"
        offset-x
      >
        <template v-slot:activator="{ on }">
          <v-btn icon v-on="on" class="mt-4 mr-0">
            <v-icon color="black">person_outline</v-icon>
          </v-btn>
        </template>

        <v-card style="width: 650px">
          <v-list class="pt-2 pl-2 pr-0">
            <v-list-tile>
              <v-list-tile-avatar>
                <v-icon color="black" size="35">account_circle</v-icon>
                <!-- <img src="https://cdn.vuetifyjs.com/images/john.jpg" alt="John">  -->
              </v-list-tile-avatar>

              <v-list-tile-content>
                <v-list-tile-title class="title mt-1"
                  >{{ c_user.firstname }} {{ c_user.lastname }} |
                  {{ c_user.abb }}</v-list-tile-title
                >
                <!-- <v-list-tile-sub-title>{{ c_user.abb }}</v-list-tile-sub-title> -->
              </v-list-tile-content>

              <!-- <v-list-tile-action> -->
              <!-- <v-btn :class="fav ? 'red--text' : ''" icon @click="fav = !fav">
                  <v-icon>mdi-heart</v-icon>
              </v-btn>-->
              <v-spacer></v-spacer>
              <v-btn icon @click="saveAsHomePage" class="mr-3">
                <v-icon :color="homePage_c ? 'yellow' : 'black'">star</v-icon>
              </v-btn>
              <!-- <v-btn icon @click="openUserSettings" class="mr-2">
                <v-icon color="black">settings</v-icon>
              </v-btn> -->
              <v-btn icon v-if="isAuthenticated" @click="logout" class="mr-1">
                <v-icon color="black">logout</v-icon>
              </v-btn>
              <!-- </v-list-tile-action> -->
            </v-list-tile>
          </v-list>
        </v-card>
      </v-menu>

      <!-- <v-btn icon v-if="isAuthenticated"> <v-icon color="red">account_circle</v-icon> </v-btn> -->
      <v-btn icon @click="sheet = true" class="mt-4 mr-2 hidden-sm-and-down">
        <v-icon>help</v-icon>
      </v-btn>

      <!-- </v-toolbar-items> -->

      <template v-slot:extension class="my-0 py-0">
        <v-layout row wrap pt-0 pb-0 my-0 mx-0>
          <v-flex xs12 class="px-0 mb-2 mx-0">
            <v-divider class="mx-0 my-0 py-0 black hidden-xs-only"></v-divider>
          </v-flex>

          <!-- MENU -->
          <v-flex
            xs3
            class="text-xs-left mx-0 pl-2 my-0"
            style="padding-left: 3px"
          >
            <a
              class="
                font-weight-regular
                display-1
                black--text
                hidden-sm-and-down
              "
              @click.stop="drawer = !drawer"
              >Menu</a
            >
            <a
              class="font-weight-regular hidden-md-and-up"
              @click.stop="drawer = !drawer"
            >
              <v-icon color="black" class="mt-2">menu</v-icon>
            </a>
          </v-flex>

          <!-- SEARCH -->
          <v-flex xs3 class="text-xs-left px-0 mt-0 mx-0 pt-0">
            <a
              v-show="showSearchButton"
              class="
                font-weight-regular
                display-1
                black--text
                hidden-sm-and-down
              "
              @click.stop="setShowSearch()"
              >Search</a
            >
            <a
              v-show="showSearchButton"
              class="font-weight-regular hidden-md-and-up"
              @click.stop="setShowSearch()"
            >
              <v-icon color="black" class="mt-2">search</v-icon>
            </a>
          </v-flex>

          <!-- VIEW -->
          <v-flex
            xs3
            class="
              text-xs-right
              px-0
              mx-0
              pt-0
              text-truncate
              hidden-sm-and-down
            "
          >
            <a
              v-show="showViewButton"
              class="font-weight-regular display-1 black--text"
              @click.stop="switchView()"
              >{{ view == 'gallery' ? 'List' : 'Gallery' }} View</a
            >
          </v-flex>

          <!-- OPTIONS -->
          <v-layout class="justify-end xs3 text-xs-right px-1 mx-0 pt-0': true">
            <!-- {'xs3': showOptionsButton && !showViewButton, 'xs1': !showOptionsButton || !showViewButton, 'xs2': showOptionsButton || showViewButton, ' -->
            <a
              v-show="showOptionsButton"
              class="
                font-weight-regular
                display-1
                black--text
                hidden-sm-and-down
              "
              @click.stop="showOptions()"
              >Options</a
            >
            <a
              v-show="showOptionsButton"
              class="font-weight-regular hidden-md-and-up"
              @click.stop="showOptions()"
            >
              <v-icon color="black" class="mt-2">settings</v-icon>
            </a>

            <!-- SORT -->
            <span
              v-show="showSortButton"
              xs1
              class="text-xs-right pr-1 mx-0 mt-1 mb-0 py-0"
            >
              <!-- <a class="font-weight-regular display-1 black--text" @click="addNew()">+</a> -->
              <!-- <div class="text-xs-right"> -->
              <v-menu
                offset-y
                :close-on-content-click="false"
                class="text-xs-right mx-4 my-0 py-0 align-center"
              >
                <template v-slot:activator="{ on }">
                  <v-btn
                    small
                    icon
                    color="black"
                    dark
                    v-on="on"
                    class="text-xs-right mx-0 mt-1 my-0 py-0"
                  >
                    <v-icon small>sort</v-icon>
                  </v-btn>
                </template>
                <v-list value="last_name">
                  <v-list-tile
                    v-for="(item, index) in sortingItems"
                    :key="index.column"
                    @click="changeSort(item.column)"
                  >
                    <v-list-tile-avatar v-if="item.column == sorting">
                      <v-icon>mdi-sort-ascending</v-icon>
                    </v-list-tile-avatar>
                    <v-list-tile-avatar v-else>
                      <v-icon></v-icon>
                    </v-list-tile-avatar>
                    <v-list-tile-title>{{ item.name }}</v-list-tile-title>
                  </v-list-tile>
                </v-list>
              </v-menu>
              <!-- </div> -->
            </span>
          </v-layout>
        </v-layout>
        <!-- </v-container> -->

        <!-- </v-toolbar-items> -->
      </template>
    </v-toolbar>

    <!-- :clipped="$vuetify.breakpoint.lgAndUp" -->
    <v-navigation-drawer
      app
      temporary
      v-model="drawer"
      dark
      hide-overlay
      style="background-color: #292929"
    >
      <v-layout row pt-3 pl-2 pb-2>
        <v-flex>
          <v-subheader class="font-weight-regular display-1 white--text">
            Menu
            <v-spacer></v-spacer>
            <a
              @click="drawer = false"
              class="font-weight-regular mr-2 display-1 white--text"
              >x</a
            >
            <!-- <v-btn small flat @click="clearFilters()">X</v-btn> -->
          </v-subheader>
        </v-flex>
      </v-layout>

      <!-- <h1 class="pl-4 pt-3 pb-2 font-weight-regular display-1 white--text">Menue</h1>
      <v-spacer></v-spacer>
      <a class=" mr-5 white--text" @click="options=false;$router.go(-1)">X</a>-->
      <v-divider class="mx-4 pb-0 mb-0"></v-divider>
      <v-list>
        <template v-for="(item, i) in user_items">
          <v-layout row v-if="item.heading" :key="i">
            <v-flex xs6>
              <v-subheader v-if="item.heading">{{ item.heading }}</v-subheader>
            </v-flex>
            <!-- <v-flex xs6 class="text-xs-center">
              <a href="#!" class="body-2 black--text">EDIT</a>
            </v-flex>-->
          </v-layout>

          <!-- :prepend-icon="item.model ? item.icon : item['icon-alt']" append-icon="" -->
          <v-list-group
            v-else-if="item.children"
            v-model="item.active"
            no-action
            :key="i"
          >
            <v-list-tile
              slot="activator"
              :to="item.path"
              style="padding-left: 8px"
            >
              <!-- <v-list-tile-action>
                <v-icon>{{ item.model ? item.icon : item['icon-alt'] }}</v-icon>
              </v-list-tile-action>-->
              <v-list-tile-content>
                <v-list-tile-title>{{ item.text }}</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>

            <!-- <v-divider class="mx-4 pb-0 mb-3 white"></v-divider> -->

            <v-list-tile
              class="pl-0 ml-0"
              v-for="(child, i) in item.children"
              :key="i"
              :to="child.path"
              active-class="default-class activeMenu"
            >
              <!-- <v-list-tile-action v-if="child.icon">
                <v-icon>{{ child.icon }}</v-icon>
              </v-list-tile-action>-->
              <!-- v-if="c_user.roles && c_user.roles.find(f => f.role == child.role)" -->
              <v-list-tile-content>
                <v-list-tile-title>{{ child.text }}</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-list-group>

          <v-list-tile
            v-else
            :to="item.path"
            v-shortkey="item.shortkey"
            @shortkey="$router.push({ path: item.path })"
            :key="i"
            active-class="default-class activeMenu"
          >
            <!-- <v-list-tile-action>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-tile-action>-->
            <v-list-tile-content style="color: white" class="pl-2">
              <v-list-tile-title>{{ item.text }}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-divider class="mx-4 pb-0 mb-0 white" :key="i + 1000"></v-divider>
        </template>

        <!-- <v-divider class="mx-4 pb-0 mb-3 white"></v-divider> -->

        <v-list-tile to="/facts" 
          active-class="default-class activeMenu"
        >
          <v-list-tile-content  style="color: white" class="pl-2">
              <v-list-tile-title>Facts & Figures</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        <v-list-group>

          <v-list-tile
            slot="activator"
            target="_blank"
            style="padding-left: 8px"
          >
            <!-- <v-list-tile-action>
            <v-icon>reset</v-icon>
            </v-list-tile-action>-->
            <v-list-tile-content>
              <v-list-tile-title>Local storage management</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile
            @shortkey="reset_store()"
            @click="reset_store()"
            target="_blank"
            style="padding-left: 8px"
            v-shortkey.once="['ctrl', 'r']"
          >
            <v-list-tile-content>
              <v-list-tile-title>Reset ALL local storage</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile
            @click="reload_data(s)"
            target="_blank"
            v-for="s in this.sections"
            :key="s"
            style="padding-left: 18px"
          >
            <!-- <v-list-tile-action>
            <v-icon>reset</v-icon>
            </v-list-tile-action>-->
            <v-list-tile-content>
              <v-list-tile-title>Load {{ s }}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list-group>

        <!-- <v-list-group> -->
        <v-divider class="mx-4 pb-0 mb-0 white"></v-divider>

        <v-list-tile
          v-if="c_user && c_user.admin"
          avatar
          onclick="window.open('https://api.tb-cms.org/artworks/generate_datauri_small')"
          target="_blank"
          style="cursor: pointer"
        >
          <v-list-tile-avatar>
            <v-icon>photo</v-icon>
          </v-list-tile-avatar>
          <v-list-tile-content>
            <v-list-tile-title>Generate New Images</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <!-- </v-list-group> -->

        <v-list-tile
          avatar
          href="http://api.tb-cms.org"
          target="_blank"
          v-if="c_user.edit"
        >
          <v-list-tile-avatar>
            <v-icon>open_in_new</v-icon>
          </v-list-tile-avatar>
          <v-list-tile-content>
            <v-list-tile-title>Go to the old version</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>

        <v-list-tile avatar dark class="dark">
          <v-list-tile-avatar>
            <!-- <img src="http://www.tb-cms.org/users/{{c_user.abb}}.jpg" > -->
            <v-icon>account_circle</v-icon>
          </v-list-tile-avatar>
          <v-list-tile-content class="pt-0 mt-0">
            <v-list-tile-title class="pt-0 mt-0">
              {{ this.c_user.firstname }} {{ this.c_user.lastname }}
              <v-btn class="pt-0 mt-0" small icon @click="logout">
                <v-icon small>open_in_new</v-icon>
              </v-btn>
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-divider></v-divider>
      </v-list>
    </v-navigation-drawer>

    <!-- FOOTER BOX FORM -->
    <div>
      <v-bottom-sheet v-model="sheet">
        <v-card ma-2>
          <v-card-title>
            <v-btn
              :depressed="show == 'help'"
              :dark="show != 'help'"
              @click="show = 'help'"
              >Help</v-btn
            >
            <v-spacer></v-spacer>
            <v-btn
              :depressed="show == 'form'"
              :dark="show != 'form'"
              @click="show = 'form'"
              >Ask question</v-btn
            >
            <!-- <v-spacer></v-spacer> -->
            <span class="subheading red--text" v-html="message_error"></span>
            <span
              class="subheading green--text"
              v-html="message_success"
            ></span>
          </v-card-title>
          <v-progress-linear
            v-show="loading"
            indeterminate
            height="3"
            class="ma-0 pa-0"
          ></v-progress-linear>
        </v-card>

        <v-card v-if="show == 'help'" color="grey lighten-4" flat mt-0>
          <v-card-text>
            <v-container fluid pa-0 ma-0>
              <v-flex xs12 mb-1 ma-0>
                <v-flex xs12 mb-1>
                  <!-- <div class="title mb-1 mx-3">Help</div> -->
                  <v-card
                    outlined
                    class="elevation-0 pb-5 pt-4"
                    color="grey lighten-4"
                    v-if="site_support_article"
                  >
                    <v-card-title class="py-0 my-0 title">{{
                      site_support_article.title
                    }}</v-card-title>
                    <v-card-text>
                      <div
                        v-html="site_support_article.subtitle"
                        class="mb-3 subtitle-1"
                      ></div>
                      <div
                        v-html="site_support_article.body"
                        class="body-1"
                      ></div>
                    </v-card-text>
                  </v-card>
                  <v-card
                    outlined
                    class="elevation-0 pb-5"
                    color="grey lighten-4"
                    v-else
                  >
                    <v-card-title class="py-0 my-0 title"
                      >No Support Article yet</v-card-title
                    >
                    <v-card-text>
                      <div class="body-1">
                        Please come back later.
                        <br />You can also contact support at
                        <a href="mailto:miro.zahorak@gmail.com"
                          >miro.zahorak@gmail.com</a
                        >
                        or click Ask Question button above to write a support
                        request.
                      </div>
                    </v-card-text>
                  </v-card>
                </v-flex>
              </v-flex>
            </v-container>
          </v-card-text>
        </v-card>

        <v-card v-if="show == 'form'" color="grey lighten-4" flat ma-0 pa-0>
          <v-card-text>
            <v-container fluid ma-0 pa-0>
              <v-layout row ma-0 pa-0>
                <v-flex xs12>
                  <v-card
                    outlined
                    class="elevation-0 pb-5"
                    color="grey lighten-4"
                  >
                    <v-card-title class="py-0 my-0 title"
                      >Ask support group a question regarding problem in this
                      section of CMS.</v-card-title
                    >
                    <v-card-text class="mb-0 pb-0">
                      <v-textarea
                        v-model="question"
                        label="Ask your question here"
                        outline
                        auto-grow
                      ></v-textarea>
                    </v-card-text>
                    <v-card-actions class="mx-2 mt-0 pt-0">
                      <v-btn :enabled="!!question" dark @click="send_question"
                        >Send</v-btn
                      >
                    </v-card-actions>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
        </v-card>
      </v-bottom-sheet>

      <v-card
        class="black my-5"
        v-if="c_user.edit && add_new"
        style="top: 145px"
      >
        <v-flex>
          <v-form @submit.prevent autocomplete="off">
            <v-layout pa-3>
              <v-flex xs12 md4 pl-4 pr-3>
                <v-text-field
                  autocomplete="off"
                  readonly
                  onfocus="this.removeAttribute('readonly');"
                  hide-details
                  v-model="new_user.login"
                  label="login"
                  solo
                ></v-text-field>
              </v-flex>

              <v-flex xs12 md4>
                <v-text-field
                  autocomplete="off"
                  readonly
                  onfocus="this.removeAttribute('readonly');"
                  hide-details
                  v-model="new_user.password"
                  label="Password"
                  type="password"
                  class="input-group"
                  solo
                ></v-text-field>
              </v-flex>

              <v-flex xs12 md4 mt-1 ml-3>
                <v-btn
                  outline
                  color="white"
                  :disabled="
                    !(new_user.login.length > 0 && new_user.password.length > 0)
                  "
                  @click="create_user"
                  >Save</v-btn
                >
                <v-btn outline color="white" @click="add_new = false"
                  >Cancel</v-btn
                >
              </v-flex>
            </v-layout>
          </v-form>
        </v-flex>
      </v-card>
    </div>
  </div>
</template>

<script>
// import detectNetwork from 'v-offline'
// import Labels from "../lists/Labels";
// import Login from '@/components/users/Login'
// import LabelsSmall from "../lists/LabelsSmall";
import yaml from 'js-yaml'
import { mapGetters, mapState } from 'vuex'
import { AUTH_LOGOUT } from '@/store/actions/auth'
import axios from '@/utils/apiClient'
import { serverBus } from '../../main'
import LocationChangeDialog from './toolbar_items/LocationChangeDialog.vue'
import ListActionMenu from '../artworks/ListActionMenu'
import constants from '@/data/constants'

function dynamicSort(property, property2) {
  console.log(property)
  console.log(property2)
  var sortOrder = 1
  if (property[0] === '-') {
    sortOrder = -1
    property = property.substr(1)
  }
  // console.log(sortOrder)
  return function (a, b) {
    var out
    // var result = (a[property] < b[property]) ? -1 : (a[property] > b[property]) ? 1 : 0;
    if (new Date(a[property]) - new Date(b[property])) {
      console.log('A1')
      return 1 * sortOrder
    }
    if (new Date(b[property]) - new Date(a[property])) {
      console.log('A-1')
      return -1 * sortOrder
    }
    if (new Date(a[property2]) - new Date(b[property2])) {
      console.log('B1')
      return 1 * sortOrder
    }
    if (new Date(b[property2]) - new Date(a[property2])) {
      console.log('B-1')
      return -1 * sortOrder
    }
    // console.log(out)
    // return out
    // * sortOrder
  }
}
export default {
  name: 'toolbar',
  constants: constants,
  // mounted: function () {

  // window.addEventListener('load', function() {
  // var status = document.getElementById("status");
  // var log = document.getElementById("log");

  // function updateOnlineStatus() {
  //   var condition = navigator.onLine ? "online" : "offline";

  //   this.online = navigator.onLine;
  //   // console.log('condition = ' + condition)
  //   // console.log('this.online = ' + this.online)
  // }

  // window.addEventListener('online',  updateOnlineStatus);
  // window.addEventListener('offline', updateOnlineStatus);
  // });
  // return navigator.onLine

  // },
  data() {
    return {
      busTitle: '',
      progressON: false,
      savingTodo: false,
      messages: [],
      showAllTodos: false,
      sortingStore: '',
      ps: { sortBy: 'created_at', descending: true },
      tp: { sortBy: 'deadline', descending: true },
      listItems: [],
      selectionSearch: '',
      todoSearch: '',
      todoHeaders: [
        { text: 'Name', value: 'title' },
        { text: 'Artwork', value: 'artwork_id' },
        { text: 'Deadline', value: 'deadline' },
        { text: 'Created at', value: 'created_at' },
      ],
      listHeaders: [
        { text: 'Selection Name', value: 'name', align: 'left' },
        { text: 'No. of Artworks', value: 'artworks.length', align: 'left' },
        { text: 'Created at', value: 'created_at', align: 'right' },
      ],
      snackbar: false,
      sTimeout: 5000,
      sColor: 'black',
      sText: 'Working on it …',
      sTextLink: '',
      sParams: '',
      sPath: '',
      todos: [],
      // sortingItems: [],
      sortingItemsArtworks: [
        { column: 'title', name: 'Title' },
        // { column: "name", name: "Artist" },
        { column: 'sort_name', name: 'Artist' },
        { column: 'accession_number_for_sorting', name: 'Accession No.' },
        { column: 'acquisition_date', name: 'Acquisition Date' },
        { column: 'created_at', name: 'Date added to CMS' },
        { column: 'production_date_new', name: 'Production Date' },
        { column: 'type_of_work_id', name: 'Type of Work' },
        { column: 'visa_status', name: 'Freeport' },
        { column: 'artwork_todos.length', name: 'Todos' },
        { column: 'location_name', name: 'Location' },
        // { column: 'ownership', name: 'Collection' },
        { column: 'id', name: 'ID' },
      ],
      sortingItemsArtists: [
        { column: 'name', name: 'Name' },
        { column: 'first_name', name: 'First Name' },
        { column: 'last_name', name: 'Last Name' },
        { column: 'sort_name', name: 'Sort Name' },
        { column: 'id', name: 'ID' },
      ],
      sortingItemsContacts: [
        { column: 'name', name: 'Name' },
        { column: 'company', name: 'Company' },
        { column: 'category', name: 'Category' },
        { column: 'artworks.length', name: 'Artworks' },
      ],
      sortingItemsSelections: [
        { column: 'name', name: 'Title' },
        { column: 'artworks.length', name: 'Artworks' },
        { column: 'created_at', name: 'Date Created' },
        { column: 'created_by', name: 'Created By' },
      ],
      sortingItemsTexts: [
        { column: 'given_filename', name: 'Title' },
        { column: 'artworks.length', name: 'Artworks' },
        { column: 'category', name: 'Type of text' },
        { column: 'created_at', name: 'Date Created' },
        { column: 'updated_at', name: 'Date Last Modified' },
        { column: 'created_by', name: 'Created By' },
      ],
      sortingItemsTodos: [
        { column: 'title', name: 'Todo' },
        { column: 'artwork.title', name: 'Artwork Title' },
        { column: 'artwork.accession_number', name: 'Accession No.' },
        { column: 'created_at', name: 'Date Created' },
        { column: 'created_by', name: 'Created By' },
      ],
      sortingItemsExhibitions: [
        { column: 'duration_start', name: 'Start Year' },
        { column: 'duration_end', name: 'End Year' },
        { column: 'title', name: 'Title' },
        { column: 'institution', name: 'Institution' },
      ],
      new_user: { firstname: '', lastname: '', login: '', password: '' },
      save_user_form_display: false,
      add_new: false,
      homePage: false,
      // account_menu: false,
      save_selection_error: false,
      fav: false,
      question: '',
      message_success: '',
      message_error: '',
      // c_user: {},
      loading: false,
      show: 'help',
      sections: [
        'Artworks',
        'Artists',
        'Contacts',
        'Users',
        'Exhibitions',
        'Locations',
        'Lists',
        'Tags',
        'Artwork Todos',
        'Artwork Texts',
        'Roles',
        'SupportArticles',
        'Journals',
      ],
      view: 'list',
      // selected: [],
      // selection_for_adding: '',
      selections_dialog: false,
      show_change_location_dialog: false,
      add_to_series_dialog: false,
      show_existing_series_picker: false,
      artwork_series: [],
      artwork_series_loading: false,
      selected_series_id: null,
      adding_to_series: false,
      reset_selection_after_series_add: false,
      selection_title: '',
      save_selection_form_display: false,
      // choose_selection_form_display: false,
      online: true,
      menu: false,
      saved_artworks: [],
      dialog: false,
      drawer: false,
      drawer2: null,
      options: this.$store.state.options,
      list: null,
      showSearch: false,
      sheet: false,
      collectionPageTitles: [
        'Collection',
        'All Collections',
        'Private Art Collection FTB',
        'Private Design Collection FTB',
        'Private Art Collection MR',
        'Deaccessioned',
        // "Old Masters",
        'Gemini Masters',
        'Gemini Collections Limited',
        'Gemini Collections Deaccessioned',
        'Private Design Casa Austria',
        'Foreign',
      ],
      artistPageTitles: ['Artists'],
    }
  },
  props: {
    source: String,
  },
  methods: {
    changeSortSelection(column) {
      if (this.ps.sortBy === column) {
        this.ps.descending = !this.ps.descending
      } else {
        this.ps.sortBy = column
        this.ps.descending = false
      }
    },
    showSnackbar(f, c) {
      // console.log("showSnackbar toolbar");
      this.snackbar = true
      this.sText = f
      // this.snackbarFieldName = f;
      if (c) {
        this.sColor = c
      }
      setTimeout(() => {
        this.sColor = 'black'
      }, 5000)
    },
    openSelectionsdialog() {
      this.listItems = this.$store.state.lists
      this.selections_dialog = true
    },
    openAddToSeriesDialog() {
      this.add_to_series_dialog = true
      this.show_existing_series_picker = false
      this.selected_series_id = null
      this.reset_selection_after_series_add = false
      this.loadArtworkSeries()
    },
    closeAddToSeriesDialog() {
      this.add_to_series_dialog = false
      this.show_existing_series_picker = false
      this.selected_series_id = null
      this.adding_to_series = false
    },
    loadArtworkSeries() {
      this.artwork_series_loading = true
      axios
        .get(`${this.$globals.apiserver}/artwork_series.json`)
        .then((response) => {
          this.artwork_series = response.data.map((series) => {
            return Object.assign({}, series, {
              searchLabel: `${series.title_en || series.title_es || 'Untitled series'} (${series.artworks ? series.artworks.length : 0})`,
            })
          })
        })
        .catch(() => {
          this.showSnackbar('Could not load artwork series.', 'red')
        })
        .then(() => {
          this.artwork_series_loading = false
        })
    },
    openNewArtworkSeries() {
      const artworkIds = this.$store.state.currentSelection.slice()
      this.closeAddToSeriesDialog()
      this.menu = false
      this.$router.push({
        path: '/artwork-series',
        query: {
          new: '1',
          artwork_ids: artworkIds.join(','),
        },
      })
    },
    addSelectionToExistingSeries(goToSeries) {
      const series = this.artwork_series.find((item) => item.id === this.selected_series_id)
      if (!series) return

      const existingArtworkIds = (series.artworks || []).map((artwork) => artwork.id)
      const selectedArtworkIds = this.$store.state.currentSelection.slice()
      const artworkIds = existingArtworkIds.concat(selectedArtworkIds.filter((id) => !existingArtworkIds.includes(id)))
      const payload = Object.assign({}, series, { artwork_ids: artworkIds })
      delete payload.artworks
      delete payload.searchLabel

      this.adding_to_series = true
      axios
        .patch(`${this.$globals.apiserver}/artwork_series/${series.id}.json`, { artwork_series: payload })
        .then(() => {
          if (this.reset_selection_after_series_add) this.clear_selection()
          this.closeAddToSeriesDialog()
          this.menu = false
          this.showSnackbar('Selected artworks added to artwork series.', 'green')
          if (goToSeries) {
            this.$router.push({
              path: '/artwork-series',
              query: { series_id: series.id },
            })
          }
        })
        .catch((error) => {
          const errors = error.response && error.response.data && error.response.data.errors
          this.showSnackbar(errors ? errors.join(', ') : 'Could not add selected artworks to artwork series.', 'red')
        })
        .then(() => {
          this.adding_to_series = false
        })
    },
    getColor(t) {
      // console.log(this.format_date(Date.now()))
      // console.log(t.deadline)
      return t.deadline < this.format_date(Date.now()) ? 'red' : 'black'
    },
    // loadTodos() {
    //   // this.todos = this.$store.state.todos.map(t => t)
    //   this.todos = this.$store.state.todos
    //   this.listItems = this.$store.state.lists
    //   // .filter(item => item.created_by === this.c_user.id)
    //   //  {
    //   //     this.todos.push({
    //   //       id: item.id,
    //   //       title: item.title,
    //   //       created_by: item.created_by,
    //   //       done: item.done,
    //   //       done_at: item.done_at,
    //   //       created_at: item.created_at,
    //   //       artwork_id: item.artwork_id
    //   //     });
    //   //   }
    //   // });

    //   // this.todos = [{ id: "1147", done: null, title: "test", created_by: 1 }];
    //   // console.log("loadTodos toolbar");
    // },
    toggleTodo(tt) {
      this.progressON = true
      var t = Object.assign({}, tt)
      // const todoIndex = this.todos.indexOf(tt);
      // this.my_todos[todoIndex].done = t.done;
      if (t.done == 0 || t.done == '') {
        t.done = 1
        t.done_at = this.format_date(Date.now())
      } else {
        t.done = 0
        t.done_at = null
      }
      // console.log(t.done);
      // t.done = !t.done;
      // console.log(this.all_todos)
      // console.log(todoIndex);
      // console.log(t);
      // this.editing = true;
      // this.save_todo()
      let url = `${this.$globals.apiserver}/artwork_todos/${t.id}.json`
      // var todoDone = {t.}
      // console.log(this.todos);
      // this.$store.dispatch('toggleTodo', tt)
      axios
        .put(url, {
          todo: { done: t.done, done_at: t.done_at },
        })
        .then((response) => {
          this.errors = {}
          // this.artwork.artwork_todos.push(response.data);
          // this.todos = [
          //   ...this.todos.map(item =>
          //     item.id !== t.id ? item : { ...item, ...t }
          //   )
          // ];
          this.showSnackbar('Todo Updated.', 'green')
          this.$store.dispatch('loadTodos')
          this.progressON = false
          // console.log(this.artwork.artwork_todos);
          // this.todos = this.artwork.artwork_todos;
          // this.all_todos = Object.assign([],this.artwork.artwork_todos)
          // this.active_todos.push(response.data);
          // this.todos.push(response.data);
          // this.editing = false;
          // this.$store.dispatch('updateArtwork', this.artwork.id)
          // this.artwork = this.$store.state.artworks.find(
          //   a => (a.id = this.artwork.id)
          // );
        })
        .catch((error) => {
          this.errors = error
        })
    },
    changeSort(item) {
      this.sortingStore = item
      // if (this.showViewButton) {
      //   this.sortingStore = this.$store.state.sorting.artworks;
      // } else {
      //   this.sortingStore = this.$store.state.sorting.artists;
      // }
      var section = this.$route.fullPath === '/artists' ? 'artists' : 'artworks'
      this.$store.dispatch('setSorting', {
        sorting: { section: section, column: item },
      })
      // console.log('sender')
      // console.log(item)
      serverBus.$emit('setSorting', item)
    },
    create_user() {
      this.sColor = 'black'
      this.snackbar = true
      this.sText = 'Saving user...'
      let url = `${this.$globals.apiserver}/users.json`
      // console.log(url)
      axios
        .post(url, this.new_user)
        .then((response) => {
          this.sPath = `/users/edit/${response.data.id}`
          this.snackbar = false
          this.snackbar = true
          this.sColor = 'green'
          this.sText = 'User Saved.'
          this.sTextLink = 'Edit new User.'
          this.result = response.data
          // var o = Object.assign({ name: this.new_user.login})
          // this.$store.dispatch('createUser', o)
          this.$store.dispatch('loadUsers')
          this.save_user_form_display = false
          // this.snackbar = false;
          this.new_user = { login: '', password: '' }
          this.add_new = false
          // console.log(this.result)
          this.$router.push({
            name: 'EditUser',
            params: { id: this.result.id, user: this.result },
          })
        })
        .catch((error) => {
          this.sColor = 'red'
          // console.log(error)
        })
    },
    saveAsHomePage() {
      // console.log(this.$route.path)
      // this.c_user.after_login_page = this.$route.path
      this.$store.dispatch('saveHomePage', this.$route.path)
    },
    // openUserSettings () {
    //   this.account_menu = false
    //   this.$router.push('/account_settings')
    // },
    send_question() {
      this.loading = true
      var question = {
        question: {
          question: this.question,
          user_id: this.c_user.id,
          url: this.$route.path,
        },
      }
      let url = `${this.$globals.apiserver}/questions.json`
      axios
        .post(url, question)
        .then((response) => {
          // console.log(response.data)
          // this.result = response.data
          this.question = this.question_c
          this.message_success = 'Message sent!'
          setTimeout(
            function () {
              this.message_success = ''
            }.bind(this),
            5000
          )
          // this.$router.push({path:`/artists/edit/${this.artist.id}`, params: {artist: this.artist}})
          this.loading = false
        })
        .catch((error) => {
          // console.log(error);
          this.message_error =
            'Problem sending the question. Please use e-mail: <a href="mailto:miro.zahorak@gmail.com" >miro.zahorak@gmail.com</a>'
          setTimeout(
            function () {
              this.message_error = ''
            }.bind(this),
            5000
          )
          this.loading = false
        })
    },
    logout: function () {
      // console.log("logout");
      this.$store.dispatch(AUTH_LOGOUT).then(() => {
        // console.log("logout then");
        this.$router.push('/login')
      })
    },
    // all items from A will be removed if they are also in B
    // subtract_from_selection (a, b) {
    //   // console.log(a.length);
    //   // console.log(b.length);
    //   c = a.filter((n) => !b.includes(n))
    //   // console.log(c.length);
    //   return c
    // },
    clearFilters() {
      this.selected_tags = []
      this.selected_tag_categories = []
    },
    format_date(date, format) {
      var moment = require('moment')
      var ndate = new Date(date)
      return moment(ndate).format('YYYY-MM-DD')
    },
    getUser(user_id) {
      var l = this.$store.state.users.find((u) => u.id === user_id)
      return l ? l : ''
    },
    ids2o(array) {
      var objs = Object.assign([], this.$store.state.artworks)
      var out = objs.filter((a) => {
        // console.log(array.includes(a.id))
        return array.includes(a.id)
      })
      return out
    },
    reset_store() {
      localStorage.clear()
      localStorage.setItem('last-reset', Date.now())
      this.$router.go('/artworks/ownership/collection')
      return false
    },
    reload_data(s) {
      // console.log("load artwork texts");
      if (s === 'Users') {
        this.$store.dispatch('loadUsers')
      } else if (s === 'Artworks') {
        this.$store.dispatch('loadArtworks')
      } else if (s === 'Artwork Texts') {
        // console.log("load artwork texts");
        this.$store.dispatch('loadTexts')
      } else if (s === 'Artists') {
        this.$store.dispatch('loadArtists')
      } else if (s === 'Contacts') {
        this.$store.dispatch('loadContacts')
      } else if (s === 'Exhibitions') {
        this.$store.dispatch('loadExhibitions')
      } else if (s === 'Locations') {
        this.$store.dispatch('loadLocations')
      } else if (s === 'Lists') {
        this.$store.dispatch('loadLists')
      } else if (s === 'Tags') {
        this.$store.dispatch('loadTags')
      } else if (s === 'Artwork Todos') {
        this.$store.dispatch('loadTodos')
      } else if (s === 'Roles') {
        this.$store.dispatch('loadRoles')
      } else if (s === 'SupportArticles') {
        this.$store.dispatch('loadSupportArticles')
      } else if (s === 'Journals') {
        this.$store.dispatch('loadJournals')
      }
      return false
    },
    test() {},
    test2() {},
    // addFilteredToSelectedSelection () {
    //   this.$store.dispatch('addFilteredToSelectedSelection', { artworks: this.filtered_artworks, title: this.selection_for_adding, updated_at: (new Date()).toISOString().substring(0, 19).replace('T', ' ') })
    // },
    saveCurrentSelectionToUser() {
      this.sColor = 'black'
      this.snackbar = true
      this.sText = 'Saving Selection...'
      this.sTextLink = ''
      // console.log(this.selection_title)
      // console.log(this.$store.state.currentSelection)
      let url = `${this.$globals.apiserver}/lists.json`
      axios
        .post(url, {
          artworks: this.$store.state.currentSelection,
          title: this.selection_title,
          user_id: this.c_user.id,
        })
        .then((response) => {
          this.snackbar = false
          this.snackbar = true
          this.save_selection_error = null
          this.result = response.data
          this.sColor = 'green'
          this.sPath = '/selections'
          this.sText = 'Selection Saved.'
          this.sTextLink = ' Go to Selections.'
          // console.log(this.result)
          this.$store.dispatch('saveCurrentSelectionToUser', {
            artworks: this.$store.state.currentSelection,
            name: this.selection_title,
            id: this.result['id'],
            created_at: this.result['created_at'],
            created_by: this.result['created_by'],
            // new Date()
            //   .toISOString()
            //   .substring(0, 19)
            //   .replace("T", " ")
          })
          this.save_selection_form_display = false
          this.selection_title = ''
        })
        .catch((error) => {
          this.save_selection_error = error
          // console.log(error);
        })
    },
    showOptions() {
      this.$store.dispatch('saveOptions', !this.options)
    },
    addNew() {
      var cond = this.$route.fullPath.indexOf('exhibition')
      if (cond > 0) {
        this.$router.push('/exhibitions/new')
      } else {
        this.$store.dispatch('addNew', !this.$store.state.add_new)
      }
    },
    setShowSearch() {
      // console.log(this.$store.state.showSearch);
      // this.showSearch = !this.showSearch
      this.$store.dispatch('setShowSearch', !this.$store.state.showSearch)
    },
    switchView() {
      // console.log(this.view)
      if (this.view === 'gallery') {
        this.$store.dispatch('saveView', 'list')
        this.view = 'list'
      } else {
        this.$store.dispatch('saveView', 'gallery')
        this.view = 'gallery'
      }
    },
    clear_selection() {
      this.$store.dispatch('clearCurrentSelection')
      this.saved_artworks = []
      serverBus.$emit('clearCurrentSelection', true)
    },
    removeArtwork(e) {
      // console.log(e.title)
      this.$store.dispatch('removeFromCurrentSelection', e)
    },
    removeFromSelections(e) {
      // console.log(e)
      this.$store.dispatch('removeFromSelections', e)
    },
    view_current_artworks() {
      return this.$store.state.currentSelection
    },
    loadSelection(e) {
      // console.log(e)
      // console.log(add)
      // if (add) {
      //   // console.log('add')
      this.$store.dispatch('saveCurrentSelection', e)
      // } else {
      //   // console.log('no add')
      //   this.$store.dispatch('addToCurrentSelection',e)
      // }
    },
    addToSelection(e) {
      console.log(e)
      // console.log(add)
      // if (add) {
      //   // console.log('add')
      // this.$store.dispatch('saveCurrentSelection',e)
      // } else {
      //   // console.log('no add')
      this.$store.dispatch('addToCurrentSelection', e)
      // }
    },
    addAllShownArtworksToCurrentSelection() {
      serverBus.$emit('addAllShownArtworksToCurrentSelection')
      this.menu = false
    },
    // view_current_artworks() {
    //   return this.$store.state.currentSelection
    // },
    save_artworks() {
      this.saved_artworks.push(this.selected)
    },
  },
  // created() {
  // this.listItems = this.$store.getters.user_lists
  // this.setSort();
  // },
  created() {
    serverBus.$on('setTitle', (a) => {
      this.busTitle = a
    })
    serverBus.$on('showSnackbar', (a, b) => {
      this.showSnackbar(a, b)
    })
    // if (this.c_user.roles.includes('todos')) {
    // console.log('created')
    // this.loadTodos()
    // }
    // this.c_user = this.$store.state.user.profile
    this.listItems = this.$store.state.lists
    this.todos = this.$store.state.todos
    // console.log(this.todos)
    this.question = this.question_c
    if (this.showViewButton) {
      this.sortingStore = this.$store.state.sorting.artworks
    } else {
      this.sortingStore = this.$store.state.sorting.artists
    }
  },
  computed: {
    selections() {
      return this.listItems
    },
    my_todos() {
      // console.log('my_todos')
      if (this.showAllTodos) {
        return this.$store.state.todos.filter((item) => item.done !== 1)
        // .sort(function(a, b) {
        //   return a.deadline ? a.deadline.localeCompare(b.deadline) : -1
        // })
      } else {
        return this.$store.state.todos.filter(
          (item) => item.created_by === this.c_user.id && item.done !== 1
        )
        // .sort(dynamicSort('deadline', 'created_at'))
      }
      // item.created_by == this.c_user.id &&
    },
    my_late_todos() {
      // console.log('my_late_todos')
      var d = new Date()
      var currentDate =
        d.toISOString().split('T')[0] + ' ' + d.toTimeString().split(' ')[0]
      return this.my_todos.filter((item) => {
        // if(item.deadline) {
        // console.log('item')
        // console.log(item.deadline)
        // console.log(Date.now())
        // console.log(currentDate)
        // console.log(item.deadline < currentDate)
        // }
        return item.deadline != null && item.deadline < currentDate
      })
    },
    // userTodos() {
    //   return Object.assign([], this.$store.state.todos).filter(
    //     t => t.created_by == this.c_user.id
    //   );
    // },
    sortingItems() {
      // console.log(this.page_title)
      if (
        this.showViewButton ||
        ['Commissions', 'Non-TBA'].some((x) => x == this.page_title)
      ) {
        return this.sortingItemsArtworks
      } else if (this.page_title == 'Artists') {
        return this.sortingItemsArtists
      } else if (this.page_title == 'Contacts') {
        return this.sortingItemsContacts
      } else if (this.page_title == 'Selections') {
        return this.sortingItemsSelections
      } else if (this.page_title == 'Todos') {
        return this.sortingItemsTodos
      } else if (this.page_title == 'Texts') {
        return this.sortingItemsTexts
      } else if (this.page_title == 'Exhibitions') {
        return this.sortingItemsExhibitions
      }
    },
    showOptionsButton() {
      return ![
        'Exhibitions - Add New',
        'Reports',
        'Artworks',
        'Facts',
        'Artists',
        'Exhibitions',
        'Contacts',
        'Contacts - Add New',
        'Texts - Add New',
        'Articles',
        'Locations',
        'CMS Users',
        'Facts, Figures and System',
      ].some((x) => x === this.page_title)
    },
    showViewButton() {
      return this.collectionPageTitles.some((x) => x === this.page_title)
    },
    isArtworkListPage() {
      return this.$route.path === '/' ||
        this.$route.path === '/artworks' ||
        this.$route.path.indexOf('/artworks/ownership/') === 0 ||
        this.$route.path.indexOf('/artworks/filter/') === 0
    },
    showSearchButton() {
      return ![
        'Reports',
        'Edit Artist',
        'Facts',
        'Artworks - Add New',
        'Exhibitions - Add New',
        'Locations - Add New',
        'CMS Users - Add New',
        'Contacts - Add New',
        'Texts - Add New',
        'CMS Users Edit',
        'Artworks',
      ].some((x) => x == this.page_title)
    },
    showSortButton() {
      return (
        this.collectionPageTitles.some((x) => x == this.page_title) ||
        this.artistPageTitles.some((x) => x == this.page_title) ||
        [
          'Commissions',
          'Non-TBA',
          'Contacts',
          'Selections',
          'Todos',
          'Exhibitions',
          'Texts',
        ].some((x) => x == this.page_title)
      )
      // 'Exhibitions','Tags','Contacts','Locations','CMS Users',
    },
    sorting() {
      return this.sortingStore
    },
    homePage_c() {
      return this.c_user.after_login_page === this.$route.path
    },
    // my_todos() {
    //   console.log(this.c_user.id )
    //   console.log(this.todos)
    //   return this.todos.filter(
    //     t => t.created_by == this.c_user.id && (t.done === false || t.done === null)
    //   )
    //   // console.log(filtered)
    //   .sort(function(a, b) {
    //     return new Date(b.created_at) - new Date(a.created_at);
    //   });
    //   // sort((a,b) => { return a.deadline < b.deadline}).
    //   // console.log(sorted)
    //   // return sorted.slice(0, 10);
    //   // return sorted
    // },
    question_c() {
      var q =
        'Hello, developer, I have a question regarding section "' +
        this.page_title +
        '".\r\r … describe question here … \r\r' +
        this.c_user.firstname
      this.question = q
      return q
    },
    site_support_article() {
      var sas = this.$store.state.support_articles.filter(
        (sa) => sa.show_in_route
      )
      // REMOVE TRAILING ID FROM PATH
      var p = this.$route.path.replace(/\d+$/, '')
      var a = sas.find((sa) =>
        yaml.load(sa.show_in_route).some((s) => s.includes(p))
      )
      return a
    },
    user_items() {
      // if (!this.c_user) {
      // this.c_user = this.$store.state.user.profile
      // }
      let newitems = []
      // let items2 = Object.entries(this.items)
      var cu = this.c_user
      var items_temp = constants.TOOLBAR_MENU_ITEMS.filter(
        (i) =>
          (cu.roles && cu.roles.some((rs) => rs.shortcut == i.role)) ||
          i.text == 'Collections'
      )

      items_temp.forEach(function (item, index, array) {
        if (cu.edit || (!item.edit_only && !cu.edit)) {
          if (item.children && cu.roles) {
            item.children = item.children.filter((ic) =>
              cu.roles.some((ur) => ur.shortcut == ic.role)
            )
          }
          // else {
          //   item.children = null
          // }
          newitems.push(item)
        }
        // newitems.push(this.items[item].children = children)
        // var a = newitems
      })
      // let newitems = this.items.filter(i => i.children.filter(ic => this.$store.state.user.roles.some(i.role)) this.$store.state.user.roles.some(i.role))
      // let newitems = this.items.filter(i => i.children.filter(ic => ic.icon == 'people'))
      return newitems
    },
    ...mapGetters(['getProfile', 'isAuthenticated', 'isProfileLoaded']),
    ...mapState({
      authLoading: (state) => state.auth.status === 'loading',
      name: (state) => `${state.user.profile.title} ${state.user.profile.name}`,
    }),
    loadErrorMessages() {
      return Object.keys(this.$store.state.load_errors).map(
        section => this.$store.state.load_errors[section]
      )
    },
    page_title() {
      let title = ''
      if (this.busTitle) {
        title = this.busTitle
      } else {
        // if (this.$route.fullPath == "/artworks/ownership/oldMasters") {
        //   title = "Old Masters";
        // } else
        if (this.$route.fullPath === '/artworks/ownership/deaccession') {
          title = 'Deaccessioned'
        } else if (this.$route.fullPath === '/artworks/ownership/collection') {
          title = 'Collection'
        } else if (this.$route.fullPath === '/artworks/ownership/all') {
          title = 'All Collections'
        } else if (this.$route.fullPath === '/artworks/ownership/pacFvh') {
          title = 'Private Art Collection FTB'
        } else if (this.$route.fullPath === '/artworks/ownership/gemini') {
          title = 'Gemini Masters'
        } else if (this.$route.fullPath === '/artworks/ownership/geminiCL') {
          title = 'Gemini Collections Limited'
        } else if (this.$route.fullPath === '/artworks/ownership/geminiCD') {
          title = 'Gemini Collections Deaccessioned'
        } else if (this.$route.fullPath === '/artworks/ownership/pdcFvh') {
          title = 'Private Design Collection FTB'
        } else if (this.$route.fullPath === '/artworks/ownership/pcCA') {
          title = 'Private Design Casa Austria'
        } else if (this.$route.fullPath === '/artworks/ownership/pacMr') {
          title = 'Private Art Collection MR'
        } else if (this.$route.fullPath === '/artworks/ownership/pcFT') {
          title = 'Private Collection FT'
        } else if (this.$route.fullPath === '/artworks/ownership/pacEh') {
          title = 'Private Collection EH'
        } else if (this.$route.fullPath === '/artworks/ownership/pacGh') {
          title = 'Private Collection GH'
        } else if (this.$route.fullPath === '/artworks/ownership/pacFh') {
          title = 'Private Collection FH'
        } else if (this.$route.fullPath === '/artworks/ownership/foreign') {
          title = 'Foreign'
        } else if (this.$route.fullPath === '/artworks/ownership/commissions') {
          title = 'Commissions'
        } else if (this.$route.fullPath === '/artworks/ownership/nonTba') {
          title = 'Non-TBA'
        } else if (this.$route.fullPath === '/artworks/ownership/com_academy') {
          title = 'Academy Commissions'
        } else if (this.$route.fullPath === '/artworks/filter/drawings') {
          title = 'Drawings'
        } else if (this.$route.fullPath === '/artworks/filter/paintings') {
          title = 'Paintings'
        } else if (this.$route.fullPath === '/artworks/filter/photographs') {
          title = 'Photo | Print'
        } else if (this.$route.fullPath === '/artworks/filter/videos') {
          title = 'Film / Video'
        } else if (
          this.$route.fullPath === '/artworks/filter/objectsAndSculptures'
        ) {
          title = 'Objects/Sculptures'
        } else if (this.$route.fullPath === '/artworks/filter/sound') {
          title = 'Sound'
        } else if (this.$route.fullPath === '/artists') {
          title = 'Artists'
        } else if (this.$route.name === 'EditArtist') {
          title = 'Edit Artist'
        } else if (this.$route.fullPath === '/tags') {
          title = 'Tags'
        } else if (this.$route.fullPath === '/tags/new') {
          title = 'Add New Tag'
        } else if (this.$route.fullPath === '/facts') {
          title = 'Facts'
        } else if (this.$route.fullPath === '/contacts') {
          title = 'Contacts'
        } else if (this.$route.fullPath === '/exhibitions') {
          title = 'Exhibitions'
        } else if (this.$route.name === 'EditExhibition') {
          title = 'Exhibitions'
        } else if (this.$route.name === 'EditArtwork') {
          title = 'Artworks'
        } else if (this.$route.name === 'EditUser') {
          title = 'CMS Users Edit'
        } else if (this.$route.name === 'EditArtwork') {
          title = 'Artworks'
        } else if (this.$route.name === 'EditContact') {
          title = 'Contacts'
        } else if (this.$route.name === 'EditArticle') {
          title = 'Article'
        } else if (this.$route.name === 'AddExhibition') {
          title = 'Exhibitions - Add New'
        } else if (this.$route.name === 'AddArtwork') {
          title = 'Artworks - Add New'
        } else if (this.$route.name === 'AddLocation') {
          title = 'Locations - Add New'
        } else if (this.$route.name === 'AddContact') {
          title = 'Contacts - Add New'
        } else if (this.$route.name === 'AddText') {
          title = 'Texts - Add New'
        } else if (this.$route.name === 'AddArtist') {
          title = 'Artists - Add New'
        } else if (this.$route.fullPath === '/lists') {
          title = 'Lists'
        } else if (this.$route.fullPath === '/users') {
          title = 'CMS Users'
        } else if (this.$route.fullPath === '/users/new') {
          title = 'CMS Users - Add New'
        } else if (this.$route.fullPath === '/reports/new') {
          title = 'Reports'
        } else if (this.$route.fullPath === '/locations') {
          title = 'Locations'
        } else if (this.$route.name === 'EditLocation') {
          title = 'Locations'
        } else if (this.$route.fullPath === '/selections') {
          title = 'Selections'
        } else if (this.$route.fullPath === '/todos') {
          title = 'Todos'
        } else if (this.$route.fullPath === '/todos/new') {
          title = 'Todos - Create New'
        } else if (this.$route.fullPath === '/articles') {
          title = 'Articles'
        } else if (this.$route.fullPath === '/public-articles') {
          title = 'Public Articles'
        } else if (this.$route.fullPath === '/public-settings') {
          title = 'Public Settings'
        } else if (this.$route.fullPath === '/texts') {
          title = 'Texts'
        } else if (this.$route.fullPath === '/texts/new') {
          title = 'Texts'
        } else if (this.$route.name === 'EditText') {
          title = 'Texts'
        } else if (this.$route.fullPath === '/artworks/ownership/collection') {
          title = 'Collection'
        }
      }
      return title
    },
    page_link() {
      let link = ''
      if (this.$route.name === 'EditExhibition') {
        link = '/exhibitions'
      } else if (this.$route.name === 'EditArtwork') {
        link = '/artworks/ownership/collection'
      } else if (this.$route.name === 'EditArtist') {
        link = '/artists'
      } else if (this.$route.name === 'EditLocation') {
        link = '/locations'
      } else if (this.$route.name === 'AddExhibition') {
        link = '/exhibitions'
      } else if (this.$route.name === 'AddArtwork') {
        link = '/artworks/ownership/collection'
      } else if (this.$route.name === 'AddLocation') {
        link = '/locations'
      } else if (this.$route.fullPath === '/users/new') {
        link = '/users'
      } else if (this.$route.name === 'EditUser') {
        link = '/users'
      } else if (this.$route.fullPath === '/reports/new') {
        link = '/reports'
      } else if (this.$route.name === 'EditText') {
        link = '/texts'
      } else if (this.$route.name === 'AddContact') {
        link = '/contacts'
      } else if (this.$route.name === 'EditContact') {
        link = '/contacts'
      } else if (this.$route.fullPath === '/texts/new') {
        link = '/texts'
      } else if (this.$route.fullPath === '/') {
        link = '/artworks/ownership/collection'
      }
      return link
    },
    select_tags() {
      var stc = this.selected_tag_categories
      var tc = this.tag_categories
      var tags = Object.assign([], this.$store.state.tags)
      var out = []
      // console.log(tags)
      tags.forEach((tag) => {
        var a = tc.filter(function (tagc) {
          return tagc.id == tag.tag_category_id
        })
        // console.log(a[0].color)
        tag.color = a[0].color
        out.push(tag)
      })
      // console.log(out)
      return out.filter(function (tag) {
        return stc.some((st) => tag.tag_category_id == st)
      })

      // return out
    },
    artworks_selections() {
      // for (var b in this.$store.state.artworks_selections) {
      // console.log(this.$store.state.artworks_selections[b])
      // }
      return Object.assign([], this.$store.getters.user_lists).reverse()
    },
    selected() {
      return this.ids2o(this.$store.state.currentSelection)
      // },
      // filtered() {
      //   return this.ids2o(this.$store.state.filterResults)
    },
  },
  components: { ListActionMenu, LocationChangeDialog },
}
</script>

<style>
.round {
  border-radius: 30px;
}
.v-badge--overlap .v-badge__badge {
  top: -5px;
  right: -3px;
}
.v-badge__badge {
  font-size: 12px;
  font-weight: 700;
  /* letter-spacing: -1px; */
  height: 18px;
  width: 18px;
}
.in_process::before {
  font-family: 'Material Icons';
  content: 'update';
  font-size: 18px;
  line-height: 1.5em;
  padding-right: 20px;
  vertical-align: middle;
}
.in_proces li {
  list-style: none;
  /* font-weight: 10; */
}
.in_process {
  font-size: 16px;
  color: green;
  /* background-image: url('somewhere.jpg'); */
  /* background-repeat: no-repeat;
    padding-left: 0px;   */
  /* width of the image plus a little extra padding */
  /* display: block;  may not need this, but I've found I do */
}
.v-list__group__items--no-action .v-list__tile {
  padding-left: 50px;
}
.v-list__group__items--no-action .v-list__tile.activeMenu {
  padding-left: 25px;
}
.activeMenu {
  border: white thin solid;
  margin: -1px 24px -1px 24px;
  padding: 10px;
}
/* .v-input--selection-controls.v-input .v-label {
  color: rgba(0,0,0,0.8);
} */
.editBG {
  background-color: #ececec !important;
}
.navbar {
  background-color: #292929 !important;
}
/* span {  font-size:18px;} line-height: 4em; */
a {
  text-decoration: none;
  color: black;
}
/* .toolbar__items a { color: #555; margin: 17px 40px 0 0px;} */
.router-link-exact-active {
  font-weight: 700;
  text-decoration: underline;
}
/* ul { width: 100%;}
  li { display:inline;} */
.logo,
.logo span {
  text-decoration: none !important;
  /* padding-top: 105px !important; */
  font-weight: 100;
  font-size: 30px;
  /* line-height: 80px; */
  color: #111;
}
.ticon {
  margin: 0 0 8px 0;
}

/* .blink {
    animation: blink 2s steps(5, start) infinite;
    -webkit-animation: blink 1s steps(5, start) infinite;
  }
  .off {
    display:none;
  }
  @keyframes blink {
    to {
      visibility: hidden;
    }
  }
  @-webkit-keyframes blink {
    to {
      visibility: hidden;
    }
  } */
</style>



// WEBPACK FOOTER //
// src/components/layout/Toolbar.vue